import {WIDTH_TEXT_VOIE} from '../constants/constants'

/** A PK interval the axis never draws narrower than `minWidth` pixels. Ends in either order. */
export type TAxisStretch = {
  kmStart: number
  kmEnd: number
  minWidth: number
}

/**
 * Pixels the stretches add to the interval [start, end], read ascending.
 * A stretch's extra is spread uniformly over its own span, so every PK
 * inside it moves in proportion and the two ends keep their distance ratio
 * with anything anchored between them. Overlapping stretches add up: each
 * keeps at least its minimum. The part of a stretch outside [start, end]
 * is not counted, which clamps one overflowing the block for free.
 */
export const stretchExtra = (
  stretches: TAxisStretch[],
  start: number,
  end: number,
  echantillon: number,
): number => {
  let extra = 0
  for (const stretch of stretches) {
    const low = Math.min(stretch.kmStart, stretch.kmEnd)
    const high = Math.max(stretch.kmStart, stretch.kmEnd)
    const span = high - low
    if (span <= 0) continue
    const shortfall = stretch.minWidth - (span / echantillon) * WIDTH_TEXT_VOIE
    if (shortfall <= 0) continue
    const overlap = Math.min(end, high) - Math.max(start, low)
    if (overlap <= 0) continue
    extra += (shortfall * overlap) / span
  }
  return extra
}
